export default [
  {
    path: '/arena-lessons',
    component: () => import('./views/Index'),
    name: 'arena-lesson',
    redirect: { name: 'arena-category-list' },
    meta: {
      navActiveLink: 'arena-category',
    },
    children: [
      {
        path: ':lesson_id',
        name: 'arena-lesson-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
